// Realtime-database/Firestore client used by the call flow (call status records read
// by the backend, mobile apps and history views). Messaging/push is staff-side only
// and will be added with the staff softphone (roadmap #41).
import { initializeApp } from 'firebase/app'
import { getDatabase } from 'firebase/database'
import { getFirestore } from 'firebase/firestore'

// Same project as the rest of the platform (a dev project is tracked in roadmap #12).
const firebaseConfig = {
  apiKey: 'AIzaSyB8muYeXvEQXDuJGHkOPgw9_akeu0BPQTg',
  authDomain: 'qr-phone-ef5ce.firebaseapp.com',
  databaseURL: 'https://qr-phone-ef5ce-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'qr-phone-ef5ce',
  storageBucket: 'qr-phone-ef5ce.appspot.com',
  messagingSenderId: '814512766448',
  appId: '1:814512766448:web:6d4e50c1d2e8c463a23135',
  measurementId: 'G-MR0JMG9NXW',
}

export const app = initializeApp(firebaseConfig)
export const database = getDatabase(app)
export const firestore = getFirestore(app)
